import { type Component } from "vue";
import { type RouteRecordRaw } from "vue-router";

export function outboxRoutes(MainLayout: Component): RouteRecordRaw {
  return {
    path: "/outbox",
    component: MainLayout,
    children: [
      {
        path: "",
        component: () =>
          import("core-fe-lib/components-shadcn/layouts/PassthroughLayout.vue"),
        children: [
          {
            path: "",
            name: "outbox",
            component: () => import("./components/OutboxList.vue"),
            meta: { requiresAuth: true },
          },
        ],
      },
    ],
  };
}
